import {
  Box,
  Grid,
  Link,
  SpaceBetween,
  FormField,
  Input,
  StatusIndicator,
  Checkbox,
  Form,
  Popover,
  Autosuggest,
} from "@cloudscape-design/components";
import { useEffect, useState } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { withAuthenticator, Authenticator } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { navigateFn } from "../../../routingHelper";
import useAxios, {
  configure,
  loadCache,
  serializeCache,
  makeUseAxios,
} from 'axios-hooks'
import { leagueId } from '../../../leagueId';
import { RotatingLines, ThreeDots, BallTriangle } from  'react-loader-spinner'
import * as awsui from "@cloudscape-design/design-tokens";
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import DatePicker from '../../../components/date-picker/DatePicker';
import { CustomButton } from "../../../components/buttons";
import { useMediaQuery } from 'react-responsive';


const apiKey = "2ff73ab3016540b097d3c5cfed50f001f3fb1ce8cf144cc7a9282ee530bb5f2f";
const baseUrl = "https://dev.formularacinggroup.au/api";
const axiosHeaders = { 
  "api-key": apiKey, 
  "Content-Type": "application/json",
}
const seriesId = ""


// function getSeriesData(pathname: string){
//   let seriesData = {
//     name: "",
//     ref: "",
//   }

//   switch (pathname) {
//     case "/f3a-series": {
//       seriesData.name = "F3A"
//       seriesData.ref = "f3a"
//       break;
//     }
//     case "/f4a-series": {
//       seriesData.name = "F4A"
//       seriesData.ref = "f4a"
//       break;
//     }
//     case "/ffa-series": {
//       seriesData.name = "Formula Ford"
//       seriesData.ref = "ffa"
//       break;
//     }
//     case "/s5000-series": {
//       seriesData.name = "S5000"
//       seriesData.ref = "s5000"
//       break;
//     }
//     case "/apjc-series": {
//       seriesData.name = "Asia Pacific Junior Esports"
//       seriesData.ref = "apjc"
//       break;
//     }
//     case "/tri-series": {
//       seriesData.name = "Tri Nations Esports Cup"
//       seriesData.ref = "tri"
//       break;
//     }
//   }

//   return seriesData;
// }


export default function Register() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  // const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]); 

  const [ username, setUsername ] = useState<string>();
  const [ email, setEmail ] = useState<string>();
  const [ givenName, setGivenName ] = useState<string>();
  const [ familyName, setFamilyName ] = useState<string>();
  const [ name, setName ] = useState<string>();
  const [ profilePicture, setProfilePicture ] = useState<string>();
  const [ groups, setGroups ] = useState<string>();
  const [ dob, setDob ] = useState<string>();
  const [ phone, setPhone ] = useState<string>();
  const [ address, setAddress ] = useState<string>();
  const [ maLicenseId, setMaLicenseId ] = useState<number>();
  const [ irUserId, setIrUserId ] = useState<string>();
  const [ irUserName, setIrUserName ] = useState<string>();
  const [ discordId, setDiscordId ] = useState<string>();
  const [ carNum, setCarNum ] = useState<string>();
  const [ secondaryCarNum, setSecondaryCarNum ] = useState<string>();
  const [ tertiaryCarNum, setTertiaryCarNum ] = useState<string>();
  const [ driverBio, setDriverBio ] = useState<string>();
  const [ agreeToSeriesRules, setAgreeToSeriesRules] = useState(false);
  const [ agreeToFrgRules, setAgreeToFrgRules] = useState(false);
  const [placeDetails, setPlaceDetails] = useState<any>();
  const {
    placesService,
    placePredictions,
    getPlacePredictions,
    isPlacePredictionsLoading,
  } = usePlacesService({
    apiKey: "AIzaSyAyAAyFRzCh2NkkvNlLEKmdWHZ1lenQ5nk",
  });
  const options = {
    fields: ["formatted_address", "geometry", "name"],
    strictBounds: false,
    types: ["establishment"],
  };
  let addressUrl = '';
  let country = '';
  let state = '';
  let postCode = 0;

  const screenWidth_800 = useMediaQuery({query: "only screen and (max-width : 800px)"})

  useEffect(() => {
    // fetch place details for the first element in placePredictions array
    if (placePredictions.length)
      placesService?.getDetails(
        {
          placeId: placePredictions[0].place_id,
        },
        (placeDetails: any) => {
          setPlaceDetails(placeDetails)
        }
      );
  }, [placePredictions]);

  // const axiosConfig = (url:string, method:string, params:{}) => {
  //   return {
  //     url: baseUrl + url,
  //     method: method,
  //     headers: axiosHeaders,
  //     params: params
  //   }
  // }

  // const [{ data: irDriverData, loading: irDriverLoading, error: irDriverError}, getIrDriver] = useAxios(axiosConfig(
  //     "/iracing_driver",
  //     "get",
  //     {
  //       irUserName: name
  //     }
  //   ), { 
  //   manual: true,
  // })

  // const [{ data: irDriverData, loading: irDriverLoading, error: irDriverError}, getIrDriver] = useAxios({
  //   url: baseUrl + "/iracing_driver",
  //   method: "get",
  //   headers: axiosHeaders,
  //   params: {
  //     irUserName: name
  //   }
  // }, { 
  //   manual: true,
  // })

  // const [{ data: leagueDriver, loading: leagueDriverLoading, error: leagueDriverError}, getLeagueDriver] = useAxios({
  //   url: baseUrl + "/league-driver",
  //   method: "get",
  //   headers: axiosHeaders,
  //   params: {
  //     leagueId: leagueId,
  //     driverId: user.getSignInUserSession()!.getIdToken().payload["custom:leagueDriverId"],
  //   },
  // });

  // const [{ data: seriesDriver, loading: seriesDriverLoading, error: seriesDriverError}, getSeriesDriver] = useAxios({
  //   url: baseUrl + "/series-driver",
  //   method: "get",
  //   headers: axiosHeaders,
  //   params: {
  //     leagueId: leagueId,
  //     seriesId: seriesId,
  //     driverId: user.getSignInUserSession()!.getIdToken().payload["custom:leagueDriverId"],
  //   },
  // });

  // const [{ data: updateLeagueDriver, loading: updateLeagueDriverLoading, error: updateLeagueDriverError}, postLeagueDriver] = useAxios({
  //   url: baseUrl + "/league-driver",
  //   method: "post",
  //   headers: axiosHeaders,
  //   data: {
  //     leagueId: leagueId,
  //     driverId: user.getSignInUserSession()!.getIdToken().payload["custom:leagueDriverId"],
  //     name: name,
  //     givenName: givenName,
  //     familyName: familyName,
  //     email: email,
  //     address: address,
  //     addressUrl: addressUrl,
  //     country: country,
  //     state: state,
  //     postCode: postCode,
  //     dob: dob,
  //     irUserId: Number(irUserId),
  //     irUserName: irUserName,
  //     carNum: carNum? Number(carNum): undefined,
  //     secondaryCarNum: secondaryCarNum? Number(secondaryCarNum): undefined,
  //     tertiaryCarNum: tertiaryCarNum? Number(tertiaryCarNum): undefined,
  //     agreeToFrgRules: agreeToFrgRules,
  //   }
  // }, {
  //   manual: true,
  // });


  // const [{ data: updateSeriesDriver, loading: updateSeriesDriverLoading, error: updateSeriesDriverError}, postSeriesDriver] = useAxios({
  //   url: baseUrl + "/series-driver",
  //   method: "post",
  //   headers: axiosHeaders,
  //   data: {
  //     leagueId: leagueId,
  //     driverId: user.getSignInUserSession()!.getIdToken().payload["custom:leagueDriverId"],
  //     carNum: Number(carNum) ? Number(carNum): undefined,
  //     secondaryCarNum: Number(secondaryCarNum) ? Number(secondaryCarNum): undefined,
  //     tertiaryCarNum: Number(tertiaryCarNum) ? Number(tertiaryCarNum): undefined,
  //     agreeToFrgRules: agreeToFrgRules,
  //     agreeToSeriesRules: agreeToSeriesRules,
  //   }
  // }, {
  //   manual: true,
  // });


  // useEffect(() => {
  //   if (leagueDriver !== undefined) {
  //     const userAttributes = user.getSignInUserSession()!.getIdToken().payload
  //     const username = userAttributes["cognito:username"]
  //     const groups = userAttributes["cognito:groups"]
      
  //     setUsername(username);
  //     setEmail(userAttributes.email);
  //     setGivenName(userAttributes.given_name);
  //     setFamilyName(userAttributes.family_name);
  //     setName(userAttributes.name);
  //     setProfilePicture(userAttributes.picture);
  //     setGroups(groups);
  //     setDob(leagueDriver.dob);
  //     setPhone(leagueDriver.phone);
  //     setAddress(leagueDriver.address);
  //     setMaLicenseId(leagueDriver.maLicenseId);
  //     setIrUserId(leagueDriver.irUserId);
  //     setIrUserName(leagueDriver.irUserName);
  //     setDiscordId(leagueDriver.discordId);
  //     setCarNum(leagueDriver.carNum);
  //     setSecondaryCarNum(leagueDriver.secondaryCarNum);
  //     setTertiaryCarNum(leagueDriver.tertiaryCarNum);
  //     setDriverBio(leagueDriver.driverBio);
  //     setAgreeToSeriesRules(leagueDriver.agreeToSeriesRules);
  //     setAgreeToFrgRules(leagueDriver.agreeToFrgRules);
  //   }
  // }, [leagueDriver]);

  // useEffect(() => {
  //   if (placeDetails !== undefined) {
  //     addressUrl = placeDetails.url ? placeDetails.url : "";
  //     placeDetails.address_components.map( ( item:any ) => {
  //       if (item.types.includes("country")) country =  item.long_name;
  //       if (item.types.includes("postal_code")) postCode = Number(item.long_name);
  //       if (item.types.includes("administrative_area_level_1")) state = item.long_name; 
  //     })
  //   }
  // }, [placeDetails]);

  // if (route !== 'authenticated') {
  //   navigate('/signin')
  // }

  return (
    <>   
      <div style={{background: "white", width: "100%", paddingTop: "50px", marginBottom: "50px", borderRadius: "10px"}}>
        {/* <div className="body-content"> */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          > 
            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
              <h2>Registrations open to Australian and New Zealand drivers via Discord</h2>
              <Box textAlign="center" >
              <Link 
                  href="https://discord.gg/unEfBYXquy"
                  target="_blank"
                >
                  <CustomButton
                    type="button"
                    onMouseEnter={ (event:any) => {
                      event.currentTarget.style.filter = `hue-rotate(110deg)`;
                    }}
                    onMouseLeave={ (event:any) => {
                      event.currentTarget.style.filter = "none";
                    }}
                    style={{
                      height: "80px", 
                      width: "100%", 
                      minWidth: "200px",
                      background: "#5865F2", 
                      borderRadius: "6px", 
                      alignItems: "center", 
                      color: "white", 
                      fontWeight: "normal", 
                      fontSize: screenWidth_800 ? "24px" : "32px", 
                      borderWidth: "0",
                      lineHeight: "35px",
                      padding: "0px 40px 0px 40px",
                      marginTop: "20px",
                    }}
                  >
                    JOIN OUR DISCORD
                  </CustomButton>
                </Link>
              </Box>
              <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%"}}>
                <img
                  src="/images/ffa/ffa-8.png"
                  alt="Formula Ford Series"
                  width={"100%"}
                  style={{borderRadius: "10px"}}
                />
              </div>
            </div>
          </div>
        {/* </div> */}
      </div>
    </>    
  );
}
